import React from "react";
import { CLASS_NAME } from "../../constants/cssClassNames";
import { Handle, Position } from "reactflow";
import { Layout } from "../../models/common";
import "./Button.css";

export interface ButtonProps {
    label: string;
    inputId?: string;
    outputId?: string;
    layout: Layout;
}

const ButtonNode = ({ label, inputId, outputId, layout }: ButtonProps) => {
    return (
        <div className={CLASS_NAME.BUTTON}>
            {inputId && (
                <Handle
                    type="target"
                    position={
                        layout === "horizontal" ? Position.Left : Position.Top
                    }
                    id={inputId}
                />
            )}
            <div className={CLASS_NAME.BUTTON_LABEL}>{label}</div>
            {outputId && (
                <Handle
                    type="source"
                    position={
                        layout === "horizontal"
                            ? Position.Right
                            : Position.Bottom
                    }
                    id={outputId}
                />
            )}
        </div>
    );
};

export default ButtonNode;
